import {Component, Input, OnInit} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';
import {Store} from '@ngxs/store';
import {NavService} from '../../../../services/nav.service';
import {NavItemCodes} from '../../../../enums/nav-item-codes.enum';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.less']
})
export class IconButtonComponent implements OnInit {
    @Input() navItem: NavItem;
    @Input() payload: any;
    @Input() icon: string;
    @Input() label: string;
    @Input() disabled = false;
    @Input() size = 'lg';
    @Input() color = 'body';
    @Input() code: NavItemCodes;
    @Input() disableNavClick = false;

    constructor(
        private store: Store,
        private navService: NavService,
    ) {
    }

    ngOnInit() {
        if (!this.navItem && this.code) {
            this.navItem = NavService.get(this.code);
        }
    }

    onClick() {
        if (this.navItem && !this.disableNavClick) {
            this.navService.handleClick(this.navItem, this.payload);
        }
    }
}
